import { graphql } from "@/gql";

export const sendMessageMutation = graphql(`
  mutation SendMessage(
    $thread_id: String!
    $body: String
    $file_paths: [String!]
  ) {
    sendMessage(thread_id: $thread_id, body: $body, file_paths: $file_paths) {
      ...ThreadMessageFields
    }
  }
`);
